<template>
    <div>
        
    </div>
</template>
    
<script>
import {mapGetters} from 'vuex';

export default {
    inject: ["getScene"],
    computed: {
        ...mapGetters(['currentSituationID','currentSituation']),
    },
    watch: {
        currentSituationID: function () {
            if(this.currentSituationID){
                let currentSituationName = this.currentSituation.getName().trim();
                let alpha = 0;
                let beta = Math.PI/2;
                switch (currentSituationName) {
                    case "Videowall": alpha = Math.PI/2.1; beta = Math.PI/1.9; break;
                    default: 
                        break;
                }

                this.getScene().activeCamera.alpha = alpha;
                this.getScene().activeCamera.beta = beta;
            }
		}
	},

}
</script>

<style>
    
</style>